import Vue from 'vue'
import { HTTP_API_V2 } from '../../http-common'

// User-provided silo capacities live in the v2 API (GET /silos/:barnId) and are
// fetched per barn. They are cached here keyed by barnId so the dashboard cards
// can render absolute fill levels. Barns without configured silos resolve to an
// empty array, which lets the card fall back to a relative level.
export default {
  state: {
    silosByBarn: {}
  },
  getters: {
    // Returns the configured silos for a barn (possibly empty), each shaped as
    // { siloNumber, capacity, critical_level, enabled }.
    silosByBarnId: (state) => (barnId) => {
      return state.silosByBarn[barnId] || []
    }
  },
  mutations: {
    setSilosForBarn (state, { barnId, silos }) {
      Vue.set(state.silosByBarn, barnId, silos)
    },
    clearSilos (state) {
      state.silosByBarn = {}
    }
  },
  actions: {
    loadSilosByBarnId ({ commit }, barnId) {
      if (!barnId) {
        return Promise.resolve([])
      }
      return HTTP_API_V2.get(`silos/${barnId}`)
        .then(result => {
          const silos = Array.isArray(result.data) ? result.data : []
          commit('setSilosForBarn', { barnId, silos })
          return silos
        })
        .catch(err => {
          console.log('error loading silos for barn: ', err)
          commit('setSilosForBarn', { barnId, silos: [] })
          return []
        })
    },
    loadSilosForBarnIds ({ state, dispatch }, barnIds) {
      const uniqueIds = Array.from(new Set((barnIds || []).filter(Boolean)))
      return Promise.all(
        uniqueIds
          .filter(barnId => state.silosByBarn[barnId] === undefined)
          .map(barnId => dispatch('loadSilosByBarnId', barnId))
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/silos/index.js